{
  "defaultLanguage": "en",
  "languages": [
    {
      "code": "en",
      "name": "English",
      "requiresGender": false
    },
    {
      "code": "fr-FR",
      "name": "French (France)",
      "requiresGender": true
    },
    {
      "code": "fr-CA",
      "name": "French (Canada)",
      "requiresGender": true
    },
    {
      "code": "es",
      "name": "Spanish (Spain)",
      "requiresGender": true
    },
    {
      "code": "es-MX",
      "name": "Spanish (Mexico)",
      "requiresGender": true
    },
    {
      "code": "it",
      "name": "Italian",
      "requiresGender": true
    },
    {
      "code": "de",
      "name": "German",
      "requiresGender": true
    },
    {
      "code": "pt-PT",
      "name": "Portuguese (Portugal)",
      "requiresGender": true
    },
    {
      "code": "pt-BR",
      "name": "Portuguese (Brazil)",
      "requiresGender": true
    },
    {
      "code": "tr",
      "name": "Turkish",
      "requiresGender": false
    },
    {
      "code": "ko",
      "name": "Korean",
      "requiresGender": false,
      "font": "Noto Sans KR"
    },
    {
      "code": "ja",
      "name": "Japanese",
      "requiresGender": false,
      "font": "Noto Sans JP"
    },
    {
      "code": "nl",
      "name": "Dutch",
      "requiresGender": false
    },
    {
      "code": "zh-TW",
      "name": "Traditional Chinese (Taiwan)",
      "requiresGender": false,
      "font": "Noto Sans TC"
    }
  ]
}
